import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';

import IntlMessages from "util/IntlMessages";
import CustomScrollbars from "util/CustomScrollbars";

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -7,
    top: 3,
    fontSize: "10px",
    border: `1px solid ${theme.palette.background.paper}`,
    padding: '2px',
  },
}))(Badge);

class StudentMenuList extends Component {
  componentDidMount() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`; // get current path

    const menuLi = document.getElementsByClassName("menu");
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {
        for (let j = 0; j < menuLi.length; j++) {
          const parentLi = that.closest(this, "li");
          if (
            menuLi[j] !== this &&
            (parentLi === null || !parentLi.classList.contains("open"))
          ) {
            menuLi[j].classList.remove("open");
          }
        }
        this.classList.toggle("open");
      };
    }

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`; // get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]'); // select current a element
    try {
      const activeNav = this.closest(activeLi, "ul"); // select closest ul
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("open");
      } else {
        this.closest(activeLi, "li").classList.add("open");
      }
    } catch (error) { }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function (fn) {
        if (typeof document.body[fn] == "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) { }

    return null;
  }

  groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
      const key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      // Add object to list for given key's value
      acc[key].push(obj);
      return acc;
    }, []);
  };

  render() {
    const { studentPages } = this.props;
    //group pages
    const result = this.groupBy(studentPages, "Menu_Id");

    return (
      <CustomScrollbars className=" scrollbar">
        <ul className="nav-menu">
          <li className="nav-header">
            <IntlMessages id="sidebar.menu" />
          </li>
          <li className="menu no-arrow">
            <NavLink to="/student/dashboard">
              <i className="zmdi zmdi-view-dashboard zmdi-hc-fw" />
              <span className="nav-text">
                <IntlMessages id="sidebar.dashboard" />
              </span>
            </NavLink>
          </li>
          <li className="menu no-arrow">
            <NavLink className="prepend-icon" to="/student/profile">
              <i className="zmdi zmdi-account zmdi-hc-fw" />
              <span className="nav-text">Profile</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink disabled className="prepend-icon" to="/student/payment">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Payments</span>
            </NavLink>
          </li>

          {Object.keys(result).map((key) => {
            {
              {
                /* const randomColor = Math.floor(Math.random()*16777215).toString(16); */
              }
            }
            return (
              <li className="menu">
                <Button className="void">
                  <i
                    className={`zmdi ${result[key][0].Menu_Icon} zmdi-hc-fw`}
                  />
                  <span className="nav-text">{result[key][0].Menu}</span>
                </Button>
                <ul className="sub-menu">
                  {result[key].map((dataItem, k) => {
                    {
                    }
                    return (
                      <li key={k}>
                        <NavLink
                          className="prepend-icon"
                          to={dataItem.Page.replace(/[^a-zA-Z]/g, "")}
                        >
                          <span className="nav-text">
                            {dataItem.Page == "AddEditCourses"
                              ? "Add/Edit Courses"
                              : dataItem.Page}
                          </span>
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}

          {/* =============Ignore below */}
          {/* <li className="ui_tooltip menu">
            <Button className="void">
              <i className="zmdi zmdi-card zmdi-hc-fw" />
              <span className="nav-text">Payments</span>
            </Button>

            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/student/payment">
                  <span className="nav-text">Make Payment</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/student/paymenthistory">
                  <span className="nav-text">Payment History</span>
                </NavLink>
              </li>
            </ul>
          </li> */}
          {/* ======  Ignore above*/}

          {/* <li className="ui_tooltip menu">
            <Button className="void">
              <i className="zmdi zmdi-folder zmdi-hc-fw" />
              <span className="nav-text">Documents</span>
            </Button>

            <ul className="sub-menu">
              <li>
                <NavLink className="prepend-icon" to="/student/docdownload">
                  <span className="nav-text">Document download</span>
                </NavLink>
              </li>
              <li>
                <NavLink className="prepend-icon" to="/student/docupload">
                  <span className="nav-text">Document Upload</span>
                </NavLink>
              </li>
            </ul>
          </li> */}

          {/* #region Courses*/}
          {/* <li className="ui_tooltip menu">
            <Button className="void">
              <i className="zmdi zmdi-file zmdi-hc-fw" />
              <span className="nav-text">Courses</span>
            </Button>

            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/student/courseRegistration"
                >
                  <span className="nav-text">Course Registration</span>
                </NavLink>
              </li>
            </ul>
          </li> */}
          {/* #endregion  */}

          {/* <li className="menu no-arrow">
            <NavLink to="/student/timetable">
              <i className="zmdi zmdi-file zmdi-hc-fw" />
              <span className="nav-text">Time Table</span>
            </NavLink>
          </li>

          <li className="menu no-arrow">
            <NavLink to="/student/learn">
              <i className="zmdi zmdi-graduation-cap zmdi-hc-fw" />
              <span className="nav-text">Learn Now</span>
            </NavLink>
          </li>


          <li className="ui_tooltip menu">
            <Button className="void">
              <i className="zmdi zmdi-file zmdi-hc-fw" />
              <span className="nav-text">Discussion Forum</span>
            </Button>

            <ul className="sub-menu">
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/student/learningDiscussion"
                >
                  <span className="nav-text">Learning Discussion</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/student/studentDiscussion"
                >
                  <span className="nav-text">Student Discussion</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  className="prepend-icon"
                  to="/student/generalDiscussion"
                >
                  <span className="nav-text">General Discussion</span>
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="menu no-arrow">
            <NavLink to="/student/assignment">
              <StyledBadge color="secondary" badgeContent="9">
                <i className="zmdi zmdi-assignment zmdi-hc-fw text-primary" />
                <span className="nav-text">Assignments</span>
              </StyledBadge>
            </NavLink>
          </li> */}
          {/*<li className="menu no-arrow">
            <NavLink to="/student/transcript">
              <i className="zmdi zmdi-file-text zmdi-hc-fw" />
              <span className="nav-text">Transcript</span>
            </NavLink>
          </li> */}
          <li className="menu no-arrow">
            <NavLink to="/student/changepassword">
              <i className="zmdi zmdi-key zmdi-hc-fw" />
              <span className="nav-text">Change Password</span>
            </NavLink>
          </li>
        </ul>
      </CustomScrollbars>
    );
  }
}

export default withRouter(StudentMenuList);
